import axiosInstance from "../../api/axiosConfig";

export const getProducts = (params: {
  limit?: number;
  page?: number;
  category?: string | null;
  name?: string | null;
  dimension?: string | null;
  side?: string | null;
  value?: number | null;
}) => {
  return axiosInstance.get("/products", { params });
};
